module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-doc.61106392.jpg";